import React from "react";
import { Container } from "react-bootstrap";
import ContentHeading from "../components/ContentHeading";
// import ContentTitle from "../components/ContentTitle";
import { ourService } from "../data";
import icon from "../assets/images/svg/service-icon.svg";
import HowWeWork from "../components/HowWeWork";
import { Helmet } from "react-helmet-async";
// import Testimonials from "../components/Testimonials";
// import Consultation from "../components/Consultation";
// import OurTeam from "../components/OurTeam";

const Service = () => {
  return (
    <div className="">
      <Helmet>
        <title>
          Our Services | Architecture, Interior & PMC by ASK & Associates
        </title>
        <meta
          name="description"
          content="Explore architecture, interior design and project management consultancy services by ASK & Associates for residential and commercial projects."
        />
        <link rel="canonical" href="https://askandassociates.com/service" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Architecture, Interior Design & PMC Services",
            provider: {
              "@type": "Organization",
              name: "ASK & Associates",
              url: "https://askandassociates.com",
            },
            areaServed: {
              "@type": "Country",
              name: "India",
            },
            serviceType: [
              "Architecture Design",
              "Interior Design",
              "Project Management Consultancy",
            ],
            description:
              "ASK & Associates offers architecture, interior design and project management consultancy services for residential and commercial projects.",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Our Services",
            url: "https://askandassociates.com/service",
            isPartOf: {
              "@type": "WebSite",
              name: "ASK & Associates",
              url: "https://askandassociates.com",
            },
          })}
        </script>
      </Helmet>
      <section className="bg-cultured section">
        <Container>
          <div className="mb-4 mb-md-5">
            <ContentHeading heading={"What We Offer"} />

            <h1 className="display-6 text-eerie-black fw-600 mb-4">
              Our Architecture & Project Management Services
            </h1>
          </div>
          <div className="row">
            {ourService.map((service) => (
              <div key={service.id} className="col-sm-6 col-md-6 col-lg-4 mb-4">
                <article className="service-section cursor-pointer">
                  <div className="overflow-hidden mb-3">
                    <img
                      className="service-img img-fluid"
                      src={service.image}
                      alt={`${service.title} service by ASK & Associates`}
                      loading="lazy"
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
                    <h3 className="h4 m-0 text-phthalo-green fw-600">
                      {service.title}
                    </h3>
                    <img
                      src={icon}
                      alt="Service details arrow icon"
                      width="24px"
                    />
                  </div>
                  <div className="border-silver-chalice border-top-0"></div>
                </article>
              </div>
            ))}
          </div>
        </Container>
      </section>
      <HowWeWork />
      {/* <OurTeam />
      <Testimonials />
      <Consultation /> */}
    </div>
  );
};

export default Service;
